module.exports = __webpack_public_path__ + "assets/3f63b5cfdf62909a12e2259de3f5cefb.png";